import '../../Styles/Legal/termsStyle.css';

function RefundPolicy() {
    return (
        <div className="terms-container">
            <h1 className="terms-header">Big Circle Auctions (BCA) – Refund Policy</h1>
            <p className="mb-2 text-sm text-gray-500">Effective Date: 10th July 2025</p>

            <p className="mb-4">
                This Refund Policy explains the terms under which payments made to Big Circle Auctions Ltd (“BCA”, “we”, “us”, or “our”) are accepted. By paying a service fee and accessing the BCA platform, you agree to this policy in full.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">1. Purpose of the Service Fee</h2>
            <ul className="list-disc pl-6 mb-4">
                <li>Grants you entry to the BCA digital environment.</li>
                <li>Enables you to view and participate in a specific auction round or process.</li>
                <li>Covers platform use, administration, and infrastructure costs.</li>
            </ul>
            <p className="mb-4">
                The service fee is not a deposit, a credit toward the item, or a fee for the auctioned item itself. It does not guarantee winning, bidding success, or even the ability to place a bid if timelines are missed.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">2. No Refunds</h2>
            <p className="mb-4">
                Once the service fee is paid and platform access is granted, no refunds will be issued under any circumstance, including but not limited to:
            </p>
            <ul className="list-disc pl-6 mb-4">
                <li>You do not win the asset/item.</li>
                <li>You do not submit a bid.</li>
                <li>You miss the auction timeframe or fail to participate.</li>
                <li>You experience technical issues or misunderstand the process.</li>
                <li>You are disqualified or restricted for violating platform rules.</li>
            </ul>
            <p className="mb-4">
                Access is granted immediately upon payment. As a result, your payment is considered final and non-refundable.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">3. Software and Digital Access</h2>
            <ul className="list-disc pl-6 mb-4">
                <li>You are purchasing a digital access service, not a product or asset.</li>
                <li>Access is delivered immediately after payment is completed.</li>
                <li>In accordance with digital commerce standards, you waive your right to cancellation or refund once access has been granted.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-2">4. Chargebacks and Disputes</h2>
            <p className="mb-4">
                Any attempt to initiate a chargeback after platform access has been provided is considered a breach of your agreement with BCA. If a chargeback is filed:
            </p>
            <ul className="list-disc pl-6 mb-4">
                <li>Your account will be permanently suspended from all future auctions.</li>
                <li>BCA reserves the right to recover funds and fees associated with the chargeback, including legal and administrative costs.</li>
                <li>We may pursue legal action or notify credit bureaus or financial institutions of misconduct.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-2">5. Duplicate Payments</h2>
            <p className="mb-4">
                If a duplicate payment is submitted in error (e.g. your card is charged twice for the same access round), you must contact BCA support within 48 hours. Upon verification, the duplicate transaction will be refunded to the original payment method.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">6. Auction Cancellations</h2>
            <p className="mb-4">
                If BCA cancels an auction before the auction round or platform access begins, and no service has been rendered, a discretionary refund may be offered. However, if access to the platform has already been granted, no refund will be due—even if the auction is later postponed or cancelled.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">7. Binding Acknowledgement</h2>
            <ul className="list-disc pl-6 mb-4">
                <li>Confirm your understanding that this is a fee for digital platform access only, not for the auctioned item.</li>
                <li>Accept that no refunds will be issued once access is granted, regardless of auction outcome or participation level.</li>
                <li>Waive any right to financial remedy for service fee payments after entry has been permitted.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-2">8. Contact Information</h2>
            <p className="mb-2">If you believe you have been incorrectly charged or require assistance with billing:</p>
            <p className="mb-2">Email: XXX@bigcircleauctions.com</p>
            <p className="mb-6">Mailing Address: 61 Bridge Street, Kington, UK, HR5 3DJ</p>

            <p className="text-sm text-gray-500">
                Big Circle Auctions reserves the right to amend this Refund Policy at any time without notice. The latest version will always be available on our website and in your user dashboard.
            </p>
        </div>
    );
}

export default RefundPolicy;
